// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WHGAp","content":"styles_content__IW_eP","tableWrap":"styles_tableWrap__2m0CC"};